export default __webpack_public_path__ + "static/media/ApplicationIcon.2cf72c04.svg";